import React, { useState, useEffect } from 'react';
import { meetAPI } from '../../services/api';
import './StudentPages.css';

const Bookings = () => {
  const [bookings, setBookings] = useState([]);
  const [filter, setFilter] = useState('upcoming');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBookings();
  }, [filter]);

  const fetchBookings = async () => {
    try {
      const params = filter === 'upcoming' ? { upcoming: 'true' } : {};
      if (filter !== 'all' && filter !== 'upcoming') {
        params.status = filter;
      }
      const response = await meetAPI.getBookings(params);
      setBookings(response.data.bookings);
    } catch (error) {
      console.error('Bookings fetch error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async (bookingId) => {
    if (window.confirm('Are you sure you want to cancel this lesson?')) {
      try {
        await meetAPI.cancelBooking(bookingId);
        fetchBookings();
      } catch (error) {
        console.error('Cancel error:', error);
      }
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return {
      day: date.getDate(),
      month: date.toLocaleDateString('en-PH', { month: 'short' }),
      time: date.toLocaleTimeString('en-PH', { hour: '2-digit', minute: '2-digit' }),
      full: date.toLocaleDateString('en-PH', { 
        year: 'numeric',
        month: 'long', 
        day: 'numeric',
        weekday: 'long'
      })
    };
  };

  const getStatusText = (status) => {
    const statusMap = {
      pending: { text: 'Pending', class: 'pending' },
      confirmed: { text: 'Confirmed', class: 'confirmed' },
      completed: { text: 'Completed', class: 'completed' },
      cancelled: { text: 'Cancelled', class: 'cancelled' }
    };
    return statusMap[status] || { text: status, class: '' };
  };

  if (loading) {
    return (
      <div className="flex-center" style={{ height: '50vh' }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <div className="bookings-page fade-in">
      <h1>📅 My Lessons</h1>
      <p className="page-subtitle">View and manage your booked lessons</p>

      {/* フィルター */}
      <div className="filter-bar" style={{ marginBottom: '24px' }}>
        <div className="filter-buttons">
          {[
            { value: 'upcoming', label: 'Upcoming' },
            { value: 'confirmed', label: 'Confirmed' },
            { value: 'completed', label: 'Completed' },
            { value: 'cancelled', label: 'Cancelled' },
            { value: 'all', label: 'All' }
          ].map((f) => (
            <button
              key={f.value}
              className={`btn ${filter === f.value ? 'btn-primary' : 'btn-outline'} btn-sm`}
              onClick={() => setFilter(f.value)}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {/* 予約リスト */}
      <div className="bookings-list">
        {bookings.map((booking) => {
          const date = formatDate(booking.scheduled_at);
          const status = getStatusText(booking.status);
          
          return (
            <div key={booking.id} className="booking-card">
              <div className="booking-date">
                <span className="day">{date.day}</span>
                <span className="month">{date.month}</span>
                <span className="time">{date.time}</span>
              </div>
              
              <div className="booking-info">
                <h3>{booking.lesson_title || 'Japanese Lesson'}</h3>
                <p>
                  with {booking.teacher_name}
                </p>
                <span className={`booking-status ${status.class}`}>
                  {status.text}
                </span>
              </div>
              
              <div className="booking-actions">
                {booking.google_meet_link && booking.status === 'confirmed' && (
                  <a 
                    href={booking.google_meet_link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-primary btn-sm"
                  >
                    📹 Join Meet
                  </a>
                )}
                {(booking.status === 'pending' || booking.status === 'confirmed') && (
                  <button 
                    className="btn btn-outline btn-sm"
                    onClick={() => handleCancel(booking.id)}
                    style={{ color: 'var(--color-danger)', borderColor: 'var(--color-danger)' }}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {bookings.length === 0 && (
        <div className="empty-state">
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>📅</div>
          <p>No lessons found</p>
        </div>
      )}
    </div>
  );
};

export default Bookings;
